import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getMyBizList } from '@/api/cmdb';
import Cookies from 'js-cookie';
var state = {
  currBiz: null,
  bizList: [],
  currBizName: ''
};
var mutations = {
  SET_CURR_BIZ: function SET_CURR_BIZ(state, currBiz) {
    state.currBiz = currBiz;
    Cookies.set('currBiz', state.currBiz, {
      expires: 30
    });
  },
  SET_BIZ_LIST: function SET_BIZ_LIST(state, bizList) {
    state.bizList = bizList;
  },
  SET_CURR_BIZ_NAME: function SET_CURR_BIZ_NAME(state, currBizName) {
    state.currBizName = currBizName;
  }
};
var actions = {
  refreshBiz: function () {
    var _refreshBiz = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var commit, list, currBiz, cachedBiz;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return getMyBizList();
          case 3:
            list = _context.sent;
            console.log(list);
            commit('SET_BIZ_LIST', list);
            if (list.length > 0) {
              currBiz = parseInt(Cookies.get('currBiz'));
              cachedBiz = list.find(function (o) {
                return o.id === currBiz;
              });
              if (cachedBiz) {
                commit('SET_CURR_BIZ', cachedBiz.id);
                commit('SET_CURR_BIZ_NAME', cachedBiz.name);
              } else {
                commit('SET_CURR_BIZ', list[0].id);
                commit('SET_CURR_BIZ_NAME', list[0].name);
              }
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function refreshBiz(_x) {
      return _refreshBiz.apply(this, arguments);
    }
    return refreshBiz;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};